import { render, staticRenderFns } from "./PreviewResume.vue?vue&type=template&id=0cfa8cc4&scoped=true&"
import script from "./PreviewResume.vue?vue&type=script&lang=js&"
export * from "./PreviewResume.vue?vue&type=script&lang=js&"
import style0 from "./PreviewResume.vue?vue&type=style&index=0&id=0cfa8cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfa8cc4",
  null
  
)

export default component.exports